import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { knowledgeCategories } from '../../../mocks/knowledgeData';

export default function KnowledgeForest() {
  const navigate = useNavigate();
  const [hoveredId, setHoveredId] = useState<string | null>(null);

  const handleCategoryClick = (categoryId: string) => {
    navigate(`/knowledge/${categoryId}`);
  };

  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-emerald-50/50 via-white to-white"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">探索知识森林</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            每一个知识板块都是一棵茁壮成长的知识树，它们相互关联，形成庞大的知识网络
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {knowledgeCategories.map((category, index) => (
            <div
              key={category.id}
              className="group relative cursor-pointer"
              onClick={() => handleCategoryClick(category.id)}
              onMouseEnter={() => setHoveredId(category.id)}
              onMouseLeave={() => setHoveredId(null)}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100 overflow-hidden">
                <div 
                  className="absolute inset-0 opacity-0 group-hover:opacity-5 transition-opacity duration-500"
                  style={{ backgroundColor: category.color }}
                ></div>
                
                <div className="relative z-10">
                  <div 
                    className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 transition-all duration-500 group-hover:scale-110"
                    style={{ backgroundColor: `${category.color}15` }}
                  >
                    <i 
                      className={`${category.icon} text-3xl`}
                      style={{ color: category.color }}
                    ></i>
                  </div>

                  <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-gray-700 transition-colors">
                    {category.name}
                  </h3>
                  
                  <p className="text-gray-600 mb-6 text-sm leading-relaxed">
                    {category.description}
                  </p>

                  <div className="space-y-2 mb-6">
                    {category.subCategories.slice(0, 3).map((sub) => (
                      <div 
                        key={sub.id}
                        className="flex items-center justify-between text-sm py-2 px-3 rounded-lg bg-gray-50 group-hover:bg-white transition-colors"
                      >
                        <span className="text-gray-700">{sub.name}</span>
                        <span className="text-gray-500 text-xs">{sub.count}篇</span>
                      </div>
                    ))}
                  </div>

                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <span className="text-sm text-gray-500">
                      共 {category.subCategories.reduce((sum, sub) => sum + sub.count, 0)} 篇文章
                    </span>
                    <div className="flex items-center text-sm font-medium group-hover:translate-x-1 transition-transform">
                      <span style={{ color: category.color }}>探索</span>
                      <i className="ri-arrow-right-line ml-1" style={{ color: category.color }}></i>
                    </div>
                  </div>
                </div>

                {hoveredId === category.id && (
                  <div className="absolute -bottom-1 -right-1 w-32 h-32 opacity-10 pointer-events-none">
                    <i className={`${category.icon} text-9xl`} style={{ color: category.color }}></i>
                  </div>
                )}
              </div>

              <div 
                className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-1 h-8 rounded-full opacity-30 group-hover:opacity-60 transition-opacity"
                style={{ backgroundColor: category.color }}
              ></div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-full">
            <i className="ri-links-line text-emerald-600"></i>
            <span className="text-sm text-gray-700">所有知识板块相互关联，形成完整的知识网络体系</span>
          </div>
        </div>
      </div>
    </section>
  );
}